import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import HeaderSection from "../../../components/HeaderSection";
import uploadFileToS3 from "../../../fileuploader/fileUploader";
import { API_URL } from "../../../url/api";

interface FormData {
  name: string;
  email: string;
  phone: string;
  attach_cv: string;
}

const TherapistContactPage: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    phone: "",
    attach_cv: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { id, value } = e.target as HTMLInputElement;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const uploadFile = async (
    e: React.ChangeEvent<HTMLInputElement & EventTarget & { files: FileList }>
  ) => {
    const file = e.target.files[0];
    const res = await uploadFileToS3(file, "shvesa", file.name);
    if (res) {
      setFormData((prevData) => ({
        ...prevData,
        attach_cv: res,
      }));
      console.log("🚀 ~ uploadFile ~ res:", res);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(
        API_URL + "therapist-contact/",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Form submitted successfully:", response.data);
      setFormData({
        name: "",
        email: "",
        phone: "",
        attach_cv: "",
      });
      setSuccessMessage(
        "Thank you for your interest! We will review your information and contact you soon!"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const doctorId = localStorage.getItem("doctorId");

    if (doctorId) {
      window.location.href = "/doctor/dashboard/";
    }
  }, []);

  return (
    <>
      <HeaderSection />
      <div className="flex w-full justify-center mt-8">
        <div className="w-full bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 max-w-6xl">
          <h2 className="text-2xl font-bold mb-4">Therapist Contact Form</h2>
          {successMessage ? (
            <div
              className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4"
              role="alert"
            >
              <div className="flex items-center">
                <div className="py-1">
                  <FaCheckCircle className="fill-current h-6 w-6 text-green-500 mr-4" />
                </div>
                <div>
                  <p className="font-bold">{successMessage}</p>
                </div>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  Name
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="phone"
                >
                  Phone
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="phone"
                  type="tel"
                  placeholder="Enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="phone"
                >
                  CV
                </label>
                <div className="flex items-center space-x-6">
                  <label className="block">
                    <span className="sr-only">Choose CV</span>
                    <input
                      id="attach_cv"
                      required
                      type="file"
                      accept="application/pdf"
                      className="block w-full text-sm text-slate-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-primary-50 file:text-gray-700
                            hover:file:bg-gray-100
                          "
                      onChange={uploadFile}
                    />
                  </label>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <button
                  className="bg-primary hover:bg-primary text-white mt-4 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default TherapistContactPage;
